import ListIcon from '@material-ui/icons/List';
import OfferList from './OfferList';
// import OfferCreate from './OfferCreate';

export default {
    list: OfferList,
    // create: OfferCreate,
    icon: ListIcon,
};
